import { render, staticRenderFns } from "./diyswiper.vue?vue&type=template&id=042d2a50&scoped=true"
import script from "./diyswiper.vue?vue&type=script&lang=js"
export * from "./diyswiper.vue?vue&type=script&lang=js"
import style0 from "./diyswiper.vue?vue&type=style&index=0&id=042d2a50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042d2a50",
  null
  
)

export default component.exports